export const BullitTitle = ({ title, nextParagraph = true }: { title: string; nextParagraph?: boolean }) =>
  nextParagraph ? `<br /><br /><b>${title}</b><br /><br />` : `<b>${title}</b>`;

export const nextParagraph = () => `<br /><br />`;

export const nextLine = () => `<br />`;

export const BullitList = ({ content }: { content: string[] }) =>
  `<ul>${content.map((item) => `<li>${item}</li>`).join("")}</ul>`;

export const LegalNoteLink = ({ url, ariaLabel, label }: { url: string; ariaLabel: string; label: string }): string =>
  `<a href=${url} aria-label=${ariaLabel}${label}>${label}</a>`;

export const MailTo = ({ mailTo, label }: { mailTo: string; label: string }) =>
  `<a href="mailto: ${mailTo}">${label}</a>`;

export const subscript = (value: string) => `<sub>${value}</sub>`;

export const superscript = (value: string) => `<sup>${value}</sup>`;

export const bold = (value: string) => `<b>${value}</b>`;

export const center = (value: string) => `<center>${value}</center>`;

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
